define([
    'WebCommon/auth',
    'WebCommon/event-bus',
    'WebCommon/events',
    'WebCommon/utils'
], function(
    Auth,
    EventBus,
    Events,
    Utils
){
    return {
        data: function(){
            return {
                auth: {
                    user: Auth.getUser(),
                    member: Auth.getMember(),
                    memberLink: Utils.genPageLink('/member')
                }
            };
        },
        computed: {
            isLoggedIn: function(){
                console.log(this.auth.user.login)
                return this.auth.user.login;
            }
        },
        methods: {
            fetchMemberInfo: Auth.fetchMemberInfo,
            logout: Auth.logout
        },
        created: function(){
            var _this = this;
            EventBus.$on(Events.UpdateMemberInfo, function(member){
                _this.auth.member = member;
                // console.log(_this.auth);
            });
        },
        destroy: function(){
            EventBus.$off(Events.UpdateMemberInfo);
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ../common/mixin/auth.js
// module id = 13
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24